import React, { useEffect, useState } from "react";
import { Tabs } from "antd";
import arrowBack from "../../../assets/images/arrow-back.png";
import AppointmentRequest from "./AppointmentRequest";
import Notification from "./Notification";
import alert from "../../../assets/images/danger_alert.png";
import axiosInstance from "../../../axios/axios";
import { ModalDialog, DataDiv, Text, RowHead, Image } from "./styles";
import { Data } from "./chats/Style";
import { Row } from "./Message/styles";
import { globalColor, globalFont } from "../../utils/RepeatFunctions/Schedule";
import {
  Decrypt_Value,
  Encrypt_Value,
} from "../../../MiddleWare/EncryptDecrypt";
import { useHistory } from "react-router-dom";

// let storedNames = localStorage.getItem("setroles");

let storedNames = localStorage.getItem("setroles")
  ? Decrypt_Value(localStorage.getItem("setroles"), "vozo")
  : {};

const { TabPane } = Tabs;

const Notifications = (props) => {
  const history = useHistory();

  const [DataCount, setDataCount] = useState(props.appData);
  const [MsgCount, setMsgCount] = useState(0);
  const [count, setCount] = useState("0");
  const [actTab, setActTab] = useState("1");

  //  Existing treatment plan data
  const [treatmentPlans, setTreatmentPlans] = useState([]);

  //  NEW high risk data
  const [highRiskData, setHighRiskData] = useState([]);

  const [generalNotificationModal, setGeneralNotificationModal] = useState(
    props.genNotification,
  );

  //  MAIN FIX — merge both notifications
  // const mergedNotifications = [...treatmentPlans, ...highRiskData];
  const mergedNotifications = [
    ...(Array.isArray(treatmentPlans) ? treatmentPlans : []),
    ...(Array.isArray(highRiskData) ? highRiskData : []),
  ];

  const success = (val) => {
    setDataCount(val);
  };

  const handleactive = (activeKey) => {
    setActTab(activeKey);
    if (activeKey === "2") {
      axiosInstance
        .get("/vozo/patient/notification/data?type=remove&id=0")
        .then(() => {
          props.getNotify();
        })
        .catch((err) => {
          console.error(err.message);
        });
    }
  };

  const handleReviewPlan = async (planID, patID, plan) => {
    let payload = {
      isReviewed: 1,
      planId: planID,
      patientId: patID,
    };
    let encrypted = Encrypt_Value(payload, "vozo");

    try {
      await axiosInstance.put("/vozo/patient/updatetreatmentPlan", encrypted);
      history.push(`/patient/treatmentplan/${patID}`, {
        planState: { planRow: plan, planForm: true },
        refreshKey: Date.now(),
      });
      props.changeDrop();
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    setCount(props.notifyCount);
    setMsgCount(props.MsgCount);

    if (props.show === false) {
      setActTab("1");
      setGeneralNotificationModal(props.genNotification);
    }
  }, [props.MsgCount, props.show, props.count, props.genNotification]);

  const today = new Date();
  const formattedDate = `${String(today.getMonth() + 1).padStart(
    2,
    "0",
  )}-${String(today.getDate()).padStart(2, "0")}-${today.getFullYear()}`;

  return (
    <ModalDialog isGeneral={generalNotificationModal}>
      {generalNotificationModal ? (
        <>
          <Row borderBottom="1px solid #cbd5e0" padding="12px 16px">
            <RowHead color="#2C7BE5">
              <Image
                src={arrowBack}
                height="24px"
                width="24px"
                cursor="pointer"
                onClick={() => setGeneralNotificationModal(false)}
              />
              <span style={{ color: "#2C7BE5", marginLeft: "8px" }}>
                General Notification
              </span>
            </RowHead>
          </Row>

          <Row
            boxShadow="5px 5px 8px rgba(20, 46, 110, 0.15)"
            radius="8px"
            border="1px solid #cbd5e0"
            margin="8px"
          >
            <Data height="336px" width="100%">
              {mergedNotifications.length === 0 ? (
                <DataDiv mt="5px">
                  <Text
                    fontFamily={globalFont}
                    fontWeight="500"
                    fontSize="14px"
                    color="rgba(46,46,46,0.75)"
                    justifyContent="center"
                  >
                    No New Notification
                  </Text>
                </DataDiv>
              ) : (
                mergedNotifications.map((row, ind) => (
                  <DataDiv
                    key={ind}
                    padding="12px 12px 12px 16px"
                    bb="1px solid #cbd5e0"
                    cursor="pointer"
                    onClick={async () => {
                      if (row.type === "screening") {
                        if (row.pat_id && row.form_id) {
                          try {
                            await axiosInstance.get(
                              `/vozo/patient/notification/data?type=activity&id=${row.id}`,
                            );

                            history.push(
                              `/scoreboard/${row.pat_id}/${row.form_id}`,
                            );
                            props.changeDrop();
                          } catch (err) {
                            console.error("High risk update error", err);
                          }
                        } else {
                          console.warn("Missing pat_id or form_id", row);
                        }
                        return;
                      }

                      if (storedNames.show_noti_viewOnly) {
                        alert("You only have view-only access.");
                      } else {
                        handleReviewPlan(row.id, row.pat_id, row);
                      }
                    }}
                  >
                    {/* HEADER */}
                    <DataDiv display="flex">
                      <DataDiv
                        textAlign="center"
                        br="40px"
                        height="24px"
                        width="24px"
                        mr="8px"
                        background="#A8AEBE"
                      >
                        <Text
                          fontFamily={globalFont}
                          fontWeight="500"
                          fontSize="14px"
                          color="#fff"
                        >
                          {row.pov_name?.charAt(0)}
                        </Text>
                      </DataDiv>

                      <Text fontFamily={globalFont} mr="20px">
                        {row.pov_name}
                      </Text>

                      <Text fontFamily={globalFont} color="#2C7BE5">
                        {formattedDate}
                      </Text>
                    </DataDiv>

                    {/* BODY */}
                    <DataDiv mt="5px">
                      {row.type === "screening" ? (
                        <>
                          <Text fontWeight="600">
                            <span>
                              <Image src={alert} />
                            </span>{" "}
                            High Risk patient alert ({row.score_display})
                          </Text>
                          <Text
                            fontSize="13px"
                            color="rgba(46,46,46,0.75)"
                            mt="5px"
                          >
                            A high risk assessment result has been recorded for{" "}
                            <span style={{ color: "#2C7BE5" }}>
                              {row.assessment}
                            </span>
                          </Text>
                        </>
                      ) : (
                        <Text>
                          Patient treatment plan is awaiting your review
                        </Text>
                      )}
                    </DataDiv>
                  </DataDiv>
                ))
              )}
            </Data>
          </Row>
        </>
      ) : (
        <>
          <DataDiv
            ml="188px"
            minWidth="16px"
            justifyContent="center"
            display="flex"
            aspectRatio="1/1"
            MaxWidth="24px"
            background={globalColor}
            br="50px"
            position="absolute"
            mt="8px"
          >
            <Text
              textAlign="center"
              fontFamily={globalFont}
              fontWeight="500"
              fontSize="12px"
              color="#ffffff"
              lineHeight="15px"
              height="100%"
              display="flex"
            >
              {DataCount.length}
            </Text>
          </DataDiv>
          <DataDiv
            ml="310px"
            minWidth="16px"
            justifyContent="center"
            alignItems="center"
            display="flex"
            aspectRatio="1/1"
            MaxWidth="24px"
            background={globalColor}
            br="50px"
            position="absolute"
            mt="8px"
          >
            <Text
              textAlign="center"
              fontFamily={globalFont}
              fontWeight="500"
              fontSize="12px"
              color="#ffffff"
              lineHeight="15px"
              height="100%"
              display="flex"
            >
              {MsgCount}
            </Text>
          </DataDiv>
          <Tabs activeKey={actTab} onChange={(k) => handleactive(k)}>
            <TabPane tab="Appointment Requests" key="1">
              <AppointmentRequest
                appData={props.appData}
                success={success}
                show={props.show}
              />
            </TabPane>

            <TabPane tab="Notifications" key="2">
              <Notification
                dropChange={props.changeDrop}
                count={count}
                setGeneralNotificationModal={setGeneralNotificationModal}
                setTreatmentPlans={setTreatmentPlans}
                setHighRiskData={setHighRiskData}
              />
            </TabPane>
          </Tabs>
        </>
      )}
    </ModalDialog>
  );
};

export default Notifications;
